import { bootstrapApplication } from '@angular/platform-browser';

import { App } from './app/app';
import { buildAppConfig } from './app/app.config';
import { environment } from './environments/environment';

void bootstrapApplication(App, buildAppConfig(environment)).catch((error) => console.error(error));
